import dayjs from 'dayjs';

//SALES TREND CHART PARSER
export const salesTrendChartParser = (data: any[], appConfig: any) => {
    try {
        const lineChartResult: any = { minVal: Number.MAX_SAFE_INTEGER, maxVal: Number.MIN_SAFE_INTEGER, data: [] };
        data.forEach((item: any, index: number) => {
            lineChartResult.minVal = Math.min(
                lineChartResult?.minVal,
                item?.bpeCurrent || Number.MAX_SAFE_INTEGER,
                item?.bpePrevious || Number.MAX_SAFE_INTEGER,
            );
            lineChartResult.maxVal = Math.max(
                lineChartResult?.maxVal,
                item?.bpeCurrent || Number.MIN_SAFE_INTEGER,
                item?.bpePrevious || Number.MIN_SAFE_INTEGER,
            );
            const lineChartTempObj = {
                period: dayjs(item?.startTimestamp).format(appConfig?.commonConfig?.dateFormatAlt),
                'Current Year': item?.bpeCurrent,
                'Year Ago': item?.bpePrevious,
            };

            lineChartResult?.data?.push(lineChartTempObj);
        });
        return lineChartResult;
    } catch (error) {
        throw error;
    }
};
